import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const SEVERITY_COLOR = {
  INFO: "var(--mq-cyan)",
  WARNING: "var(--mq-yellow)",
  CRITICAL: "var(--mq-red)",
};

export default function AlertLog() {
  const { t } = useI18n();
  const [alerts, setAlerts] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/alerts", { params: { limit: 30 } });
      setAlerts(data);
    } catch (err) {
      console.warn("AlertLog /alerts fetch failed:", err?.message || err);
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="mq-panel h-full flex flex-col" data-testid="alert-log">
      <div className="mq-panel-header">
        <span className="mq-heading text-sm font-semibold tracking-wider">
          {t("alerts")}
        </span>
        <span className="mq-label">{alerts.length}</span>
      </div>
      <div className="overflow-y-auto flex-1 max-h-[420px]">
        {alerts.length === 0 ? (
          <div className="p-4 text-xs text-[var(--mq-text-3)]">{t("noAlerts")}</div>
        ) : (
          alerts.map((a, idx) => (
            <div
              key={`${a.ts}-${idx}`}
              className="px-4 py-2 text-xs border-b"
              style={{ borderColor: "var(--mq-border)" }}
              data-testid={`alert-row-${idx}`}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="mq-label" style={{ color: SEVERITY_COLOR[a.severity] || "var(--mq-text-2)" }}>
                  [{a.severity}] {a.event}
                </span>
                <span className="text-[10px] text-[var(--mq-text-3)]">
                  {new Date((a.ts || 0) * 1000).toLocaleTimeString()}
                </span>
              </div>
              <div className="text-[var(--mq-text-2)] break-words">{a.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
